import { createAction, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';

import { Section } from 'src/app/models/section';

export const getSections = createAction('[Section] Get Sections', props<{ templateId: number }>());

export const getSectionsSuccess = createAction('[Section] Get Sections Success', props<{ sections: Section[] }>());

export const getSectionsError = createAction('[Section] Get Sections Error', props<{ err: HttpErrorResponse }>());

export const getSection = createAction('[Section] Get Section', props<{ sectionId: number }>());

export const getSectionSuccess = createAction('[Section] Get Section Success', props<{ selectedSection: Section }>());

export const getSectionError = createAction('[Section] Get Section Error', props<{ err: HttpErrorResponse }>());

export const saveSectionsSortingOrder = createAction(
  '[Section] Save Sections Sorting Order',
  props<{ templateId: number; sortingOrder: number[] }>()
);

export const saveSectionsSortingOrderSuccess = createAction(
  '[Section] Save Sections Sorting Order Success',
  props<{ sortingOrder: number[] }>()
);

export const saveSectionsSortingOrderError = createAction(
  '[Section] Save Sections Sorting Order Error',
  props<{ err: HttpErrorResponse }>()
);

export const setSelectedSection = createAction('[Section] Set Selected Section', props<{ selectedSection: Section }>());

export const createSection = createAction('[Section] Create Section', props<{ section: Section }>());

export const createSectionSuccess = createAction(
  '[Section] Create Section Success',
  props<{ createdSection: Section }>()
);

export const createSectionError = createAction('[Section] Create Section Error', props<{ err: HttpErrorResponse }>());

export const updateSection = createAction('[Section] Update Section', props<{ section: Section }>());

export const updateSectionSuccess = createAction(
  '[Section] Update Section Success',
  props<{ updatedSection: Section }>()
);

export const updateSectionError = createAction('[Section] Update Section Error', props<{ err: HttpErrorResponse }>());

export const deleteSection = createAction('[Section] Delete Section', props<{ section: Section }>());

export const deleteSectionSuccess = createAction(
  '[Section] Delete Section Success',
  props<{ deletedSection: Section }>()
);

export const deleteSectionError = createAction('[Section] Delete Section Error', props<{ err: HttpErrorResponse }>());

export const noopAction = createAction('[Section] No Operations Action');
